import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.GESTAO_ATA.BUSCAR_LISTAGEM_HISTORICO_PRORROGACAO](context, filtro) {
		const { data } = await api.gestaoAta.buscarListagemHistoricoProrrogacao(filtro)
		return data
	},
	async [actionTypes.ATA.GESTAO_ATA.EXCLUIR_PRORROGACAO](context, idProrrogacao) {
		return await api.gestaoAta.excluirProrrogacao(idProrrogacao)
	},
	async [actionTypes.ATA.GESTAO_ATA.BUSCAR_ITENS_ATA_BOTAO_HISTORICO](context, parametros) {
		const { data } = await api.gestaoAta.buscarItensAtaBotaoHistorico(parametros)
		return data
	},
}
